module.exports = __webpack_public_path__ + "assets_app/img/header_list.58e01208.svg";